import { RiArrowRightSLine } from '@remixicon/react';

const SettingsRow = ({ icon: Icon, title, subtitle, onClick, hideChevron = false, disabled = false }) => {
  const interactive = typeof onClick === 'function' && !disabled;
  const dimmed = disabled;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!interactive}
      className={`w-full flex items-center gap-4 px-4 py-3.5 text-left transition-colors ${
        interactive ? 'hover:bg-gray-50 cursor-pointer' : 'cursor-default'
      } ${dimmed ? 'opacity-60' : ''}`}
    >
      <span className={`flex-shrink-0 ${dimmed ? 'text-gray-400' : 'text-gray-500'}`}>
        <Icon className="w-5 h-5" />
      </span>
      <span className="flex-1 min-w-0">
        <span className={`block text-sm font-semibold truncate ${dimmed ? 'text-gray-500' : 'text-gray-900'}`}>{title}</span>
        {subtitle && (
          <span className={`block text-xs truncate mt-0.5 ${dimmed ? 'text-gray-400' : 'text-gray-500'}`}>{subtitle}</span>
        )}
      </span>
      {!hideChevron && interactive && (
        <RiArrowRightSLine className="w-5 h-5 text-gray-400 flex-shrink-0" />
      )}
    </button>
  );
};

export default SettingsRow;
